import { Directive, Input, TemplateRef, ViewContainerRef, OnInit, OnDestroy } from '@angular/core';
import { PermissionService } from 'app/core/auth/permission.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UserService } from 'app/core/user/user.service';

@Directive({
    selector: '[appHasPermission]'
})
export class HasPermissionDirective implements OnInit, OnDestroy {
    @Input('appHasPermission') permissions: string | string[] = [];
    @Input('appHasPermissionElse') elseTemplate: TemplateRef<any> | null = null;
    
    private _destroy$ = new Subject<void>();
    private _hasView = false;

    constructor(
        private _permissionService: PermissionService,
        private _templateRef: TemplateRef<any>,
        private _viewContainer: ViewContainerRef,
        private _userService: UserService 
    ) {}

    ngOnInit(): void {
        // Re-check when user changes (login/logout)
        this._userService.user$
            .pipe(takeUntil(this._destroy$))
            .subscribe(() => {
                this._updateView();
            });
    }

    ngOnDestroy(): void {
        this._destroy$.next();
        this._destroy$.complete();
    }

    private _updateView(): void {
        const requiredPermissions = Array.isArray(this.permissions) 
            ? this.permissions 
            : [this.permissions];
            
        // If no permissions defined, assume allowed (or optional logic: default denied)
        if (requiredPermissions.length === 0) {
            this._showThen();
            return;
        }

        const hasPermission = this._permissionService.hasAnyPermission(requiredPermissions);
        if (hasPermission) {
            this._showThen();
        } else {
            this._showElse();
        }
    }

    private _showThen(): void {
        if (!this._hasView) {
            this._viewContainer.clear();
            this._viewContainer.createEmbeddedView(this._templateRef);
            this._hasView = true;
        }
    }

    private _showElse(): void {
        this._viewContainer.clear();
        this._hasView = false;
        if (this.elseTemplate) {
            this._viewContainer.createEmbeddedView(this.elseTemplate);
        }
    }
}
